module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-200italic.woff2?de4421341942d11714a20399e6ba09ef";